import * as React from 'react';
import TextField from '@mui/material/TextField';
import { Button } from '@mui/material';
import MovieContext from './context/store';

const Language = ({getdata}) => {

    const context = React.useContext(MovieContext);
    const inputRef = React.useRef();

    const handleClick = (event) => {
        context.handleLanguage(inputRef.current.value);
        getdata();
    }

    return (
        <div>
            <h1>Which language do you speak?</h1>
            
     <form onSubmit={handleClick}>
     <TextField inputRef={inputRef} style={{width:"100%",maxWidth:'400px'}} id="standard-basic" label="Type language here" variant="standard" /> 
     <p></p><Button onClick={() => handleClick()} variant='contained'>Select</Button>

     </form>
      
    
        </div>
    )
}

export default Language;